export default __webpack_public_path__ + "static/media/assignment-details.bc198913.png";